import { ModuleWithProviders, NgModule } from '@angular/core';

@NgModule({
  imports: [
  ],
  declarations: [
  ],
  exports: [
  ]
})
export class LosAuthV2Module {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LosAuthV2Module
    };
  }
}
